<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-2">
          <v-card-title>
            ข้อมูลสำนักงานใหญ่
          </v-card-title>
          <v-card-text>
            <v-form ref="information" @submit.prevent="save_data">
              <div class="grid_half">
                <div class="mt-3 ma-1">
<!--                  <div class="ma-2">ชื่อบริษัท (ไทย)</div>-->
                  <v-text-field color="#86bc3a" type="text" label="ชื่อบริษัท(ไทย)" v-model="contact_data.name" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
<!--                  <div class="ma-2">ชื่อบริษัท (ภาษาอังกฤษ)</div>-->
                  <v-text-field color="#86bc3a" type="text" label="ชื่อบริษัท(ภาษาอังกฤษ)" v-model="contact_data.name_eng" hide-details="auto" outlined></v-text-field>
                </div>
              </div>
              <div class="grid_full">
                <div class="mt-3 ma-1">
                  <v-textarea color="#86bc3a" type="text" label="ที่อยู่" v-model="contact_data.address" hide-details="auto" outlined></v-textarea>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="เวลาทำการ" v-model="contact_data.open_time" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Google Map" v-model="contact_data.google_map" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="tel" @keypress="isNumber($event, contact_data.telephone)" v-model="contact_data.telephone" maxlength="11" label="เบอร์โทรติดต่อ" hide-details="auto" outlined></v-text-field>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Facebook Page (ชื่อเพจ)" v-model="contact_data.fb_page" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Facebook Page (Link)" v-model="contact_data.fb_link" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Instagram (ชื่อ)" v-model="contact_data.ig_page" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Instagram (Link)" v-model="contact_data.ig_link" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Shopee (ชื่อร้าน)" v-model="contact_data.shopee_page" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Shopee (Link)" v-model="contact_data.shopee_link" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Line Official Account (ชื่อร้าน)" v-model="contact_data.line_page" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Line Official Account (Link)" v-model="contact_data.line_link" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Lazada (ชื่อร้าน)" v-model="contact_data.lazada_page" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 ma-1">
                  <v-text-field color="#86bc3a" type="text" label="Lazada (Link)" v-model="contact_data.lazada_link" hide-details="auto" outlined></v-text-field>
                </div>
              </div>
              <div class="text-center pt-6">
                <v-btn large class="white--text grad-success-bg mobile_btn" style="font-size: 18px" type="submit">บันทึก</v-btn>
              </div>
            </v-form>
          </v-card-text>
        </div>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {isTelephone} from "@/js/handler";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Contact_information",
  data() {
    return {
      loading_page: false,
      overlay: false,
      alert_success: false,
      data_list: {
        telephone: '',
      },
      contact_data: [],
    }
  },
  methods: {
    isNumber: function(evt, number) {
      return isTelephone(evt, number)
    },
    get_contact_data() {
      this.loading_page = true
      HTTP.post('/manage-website/contactus/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.contact_data = res.data.object
            }
          })
    },
    save_data() {
      Swal.fire({
        title: 'คุณต้องการอัพเดทข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          // this.overlay = true
          HTTP.post('/manage-website/contactus/edit', {
            data_list: this.contact_data
          }).then((res) => {
            if (res.data.success === true) {
              // this.overlay = false
              this.alert_success = true
              this.get_contact_data()
              setTimeout(() => this.alert_success = false, 3000)
            }
          })
        }
      })
    },
  },
  mounted() {
    this.get_contact_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
.mobile_btn {
  width: 30%;
}
@media only screen and (max-width: 1180px) {
  .mobile_btn {
    width: 40%;
  }
}
@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }
}
</style>
